export const MIN_LOOKBACK_SECONDS = 300; // 5mins
export const DEFAULT_LOOKBACK_SECONDS = 3600; // Last 1 hour
export const DEFAULT_WIDGET_CONFIG = { selected_time: { lookbackSeconds: 86400 }, severity: 'all', state: 'all' };
export const SIDEBAR_WIDTH = 425;
